// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournament-invitation-inscription-setup__container {
    padding: var( --space-and-half );
}

.tournament-invitation-inscription-setup__col {
    width: 30%;
}

.tournament-invitation-inscription-setup__container .enrolled-team {
    margin-right: var( --space-half );
    padding: var( --space ) var( --space-and-half );
    width: 100%;
    border: 1px solid var(--new-gray-background-color);
    border-radius: 18px;
}

.tournament-invitation-inscription-setup__search-input input{
    background: transparent;
    width: 100%;
    border-style: none;
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc( var(--space) + 1px );
    line-height: calc( var(--space-and-half) - 2px );;
    display: flex;
    align-items: center;
    letter-spacing: 0.001em;
    color: var(--basic-gray-color);
    padding: var(--space-half-quarter) 0;
}

.tournament-invitation-inscription-setup__search-input {
    width: 32%;
    margin: var( --space-and-half ) 0 !important;
    background: var(--new-gray-background-color);
    border-radius: calc( var(--space-and-half) - 2px );
}

.tournament-invitation-inscription-setup__search-input .MuiInput-underline:before,
.tournament-invitation-inscription-setup__search-input .MuiInput-underline:hover:not(.Mui-disabled):before {
    border: none;
}

.tournament-invitation-inscription-setup__search-input .icon-search {
    font-size: 20px;
    margin-left: var( --space-half );
    margin-right: var( --space-half-quarter );
    color: #949F9A;
}

.tournament-invitation-inscription-setup__no-inscriptions__msg {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.tournament-invitation-inscription-setup__no-inscriptions__msg.baloa-table-column {
    color: var( --basic-gray-color );
}

.tournament-invitation-inscription-setup__container .icon-ball {
    color: var(--white-color);
    padding: 5px;
    font-size: 30px;
    border-radius: 50%;
}

.tournament-invitation-inscription-setup__team {
    display: flex;
    align-items: center;
    /* margin-bottom: var( --space-x2 ); */
}

/* .tournament-invitation-inscription-setup__team.is-register {
    margin-bottom: var( --space-half-quarter );
} */

.tournament-invitation-inscription-setup__enrolled-team {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: var( --space-and-half );
}

.tournament-invitation-inscription-setup__container img {
    width: 40px;
    height: 40px;
    border-radius: 50%;
}

.tournament-invitation-inscription-setup__col .request-counter {
    margin: var( --space-half-quarter ) 0 var( --space ) 0;
}

.tournament-invitation-inscription-setup__team-info {
    margin-left:  var(--space-half-quarter);
    min-height: calc( var( --space-x3 ) - var( --space-half ) );
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.tournament-invitation-inscription-setup__team-info .baloa-table-column {
    color: var( --primary-very-dark-color );
}

.tournament-invitation-inscription-setup__team-info .baloa-username {
    color: var( --primary-dark-color );
}

.progress {
    margin: var(--space-half-quarter) 0 var(--space-half) 0;
    padding: 0;
    width: 50%;
    height: calc( var(--space-quarter) + var(--space-eighth));
    overflow: hidden;
    background: var( --body-background-color );
    border-radius: calc( var(--space-quarter) + var(--space-eighth));
  }
  
.bar {
    position:relative;
    float:left;
    min-width:1%;
    height:100%;
    background:var( --new-green-color );
}

.enrolled-players.baloa-table-column {
    font-size: var( --space-half-quarter );
    line-height: calc( var( --space-half-quarter ) + var( --space-eighth) );
    color: var( --basic-gray-color );
    margin-top: 11px;
}

.tournament-invitation-inscription-setup__teams-filter {
    display: flex;
    align-items: center;
}

.filter-label.baloa-table-column {
    color: var( --basic-gray-color );
    margin-right: var( --space-half );
    padding: var( --space-half ) var( --space );
    border-radius: var( --space-and-half );
    border: 2px solid var( --basic-gray-color );
    cursor: pointer;
}

.tournament-invitation-inscription-setup__title {
    display: flex;
    justify-content: space-between;
}

.tournament-invitation-inscription-setup__title .baloa-table-column {
    color: var( --primary-dark-color );
    text-transform: capitalize;
    margin-bottom: var( --space-and-half );
}

.filter-label.baloa-table-column.selected-state {
    color: var( --new-green-color );
    background-color: #EAF7F0;
    border: 2px solid var(--new-green-color);
}

.tournament-invitation-inscription-setup__team-container {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 14px 16px 12px 16px;
    border-bottom: 1px solid var(--new-gray-background-color);
    width: 100%;
}

.tournament-invitation-inscription-setup__team-container:last-child {
    border-bottom: none;
}

.tournament-invitation-inscription-setup__team-container-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding: 12px 16px;
    align-items: flex-start;
    border-radius: 8px 8px 0px 0px;
    background: var(--new-background-color);
    margin-top: 12px;
}

.tournament-invitation-inscription-setup__team-container-header__empty-div {
    width: 120px;
}

.tournament-invitation-inscription-setup__col__form-and-payment {
    display: flex;
    align-items: center;
    gap: 10px;
    justify-content: flex-start;
    margin-top: calc(var(--space) + 4px);
    width: 20%;
}

.tournament-invitation-inscription-setup__col__form-and-payment__label {
    padding: 2px 6px;
    border-radius: 25px;
    border: 1px solid var(--basic-gray-color);
    background: rgba(113, 132, 123, 0.15);
}

.tournament-invitation-inscription-setup__col__form-and-payment__label.baloa-username {
    color: var(--basic-gray-color);
}

.tournament-invitation-inscription-setup__col__form-and-payment__label.realized {
    border: 1px solid var(--new-green-color);
    background: rgba(48, 179, 107, 0.15);
}

.tournament-invitation-inscription-setup__col__form-and-payment__label.baloa-username.realized {
    color: var(--new-green-color);
}

.tournament-invitation-inscription-setup__col__form-and-payment .hubicon-view_form::before,
.tournament-invitation-inscription-setup__col__form-and-payment .hubicon-payment_info::before {
    font-size: 22px;
    opacity: 0.64;
    cursor: pointer;
}

.tournament-invitation-inscription-setup__col__invited-actions,
.tournament-invitation-inscription-setup__col__registered-actions,
.tournament-invitation-inscription-setup__col__enrolled-actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin-top: var( --space );
    width: 30%;
}

.tournament-invitation-inscription-setup__col__invited-actions .primary-button,
.tournament-invitation-inscription-setup__col__registered-actions .primary-button,
.tournament-invitation-inscription-setup__col__enrolled-actions .primary-button{
    background: #EAF7F0;
    border: 3px solid var(--new-green-color);
    color: var(--new-green-color);
}

.tournament-invitation-inscription-setup__col__registered-actions .icon-options,
.tournament-invitation-inscription-setup__col__invited-actions .icon-options  {
    margin: 0 calc( var(--space-half) + var(--space-eighth) );
    cursor: pointer;
}

.tournament-invitation-inscription-setup__col__invited-actions .invited {
    background-color: var(--new-blue-color);
}

.tournament-invitation-inscription-setup__col__enrolled-actions .enrolled {
    background-color: var( --new-green-color );
    padding: var( --space-quarter ) var( --space-half );
    justify-self: flex-start;
    margin-right: auto;
}

.tournament-invitation-inscription-setup__col__invited-actions .expired {
    background-color: var( --basic-gray-color );
    max-width: calc( var(--space-x3) * 3 );
    margin-right: calc( var(--space-x3) + var(--space-and-half) - var(--space-eighth)) !important;
    white-space: nowrap;
}

.tournament-invitation-inscription-setup__col__registered-actions .baloa-username.rejected {
    background-color: var( --error-color );
    color: var( --white-color );
    white-space: nowrap;    
}

.tournament-invitation-inscription-setup__col__enrolled-actions .baloa-username.refused {
    background-color: var( --error-color );
    color: var( --white-color );
    white-space: nowrap;
    margin-right: auto;
    padding: var( --space-quarter ) var( --space-half );
}

.tournament-invitation-inscription-setup__col__registered-actions .baloa-username.register {
    background-color: var( --new-yellow-color );
    max-width: calc( var(--space-x3) * 3 );
    white-space: nowrap;
    color: var( --white-color );
}

.tournament-invitation-inscription-setup__col__registered-actions .baloa-username.cancelled {
    background-color: var( --error-color );
    color: var( --white-color );
    white-space: nowrap;
    padding: var( --space-quarter ) var( --space-half );
}

.tournament-invitation-inscription-setup__col__enrolled-actions .baloa-username {
    color: var( --white-color );
    font-size: calc( var( --space-half-quarter ) - 1px);
    line-height: calc( var( --space-half-quarter ) + 1px);
    border-radius: var( --space-and-half );    
    font-weight: var( --font-medium );
}

.tournament-invitation-inscription-setup__col__invited-actions .baloa-username {
    margin-right: auto;
    color: var( --white-color );
    font-size: calc( var( --space-half-quarter ) - 1px);
    line-height: calc( var( --space-half-quarter ) + 1px);
    padding: var( --space-quarter ) var( --space-half );
    border-radius: var( --space-and-half );    
    font-weight: var( --font-medium );
}

.tournament-invitation-inscription-setup__col__registered-actions .baloa-username {
    color: var( --white-color );
    font-size: calc( var( --space-half-quarter ) - 1px);
    line-height: calc( var( --space-half-quarter ) + 1px);
    padding: var( --space-quarter ) var( --space-half );
    border-radius: var( --space-and-half );    
    font-weight: var( --font-medium );
    justify-self: flex-start;
    margin-right: auto;
}

.tournament-invitation-inscription-setup__validate.baloa-username {
    color: var( --new-green-color );
    cursor: pointer;
    padding: 0;
}

.tournament-invitation-inscription-setup__col__invited-actions span.icon-x {
    background: var( --new-gray-background-color );
    color: var( --primary-dark-color );
    border-radius: 50%;
    cursor: pointer;
    font-size: var( --space );
    padding: var( --space-quarter );
    width: var( --space-and-half );
    height: var( --space-and-half );
    display: flex;
    align-items: center;
    justify-content: center;
}

.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__form-and-payment,
.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__registered-actions {
    margin-top: 0;

}

.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__registered-actions {
    justify-content: flex-start;
}

.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col.baloa-table-column,
.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__form-and-payment.baloa-table-column,
.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__registered-actions.baloa-table-column {
    color: var(--new-primary-very-dark-color);
}

.tournament-invitation-inscription-setup__invited-tooltip {
    padding: var( --space-half ) var( --space-half-quarter );
    background: var( --primary-dark-color );
    border-radius: var( --space-and-half );
    position: absolute;
    right: var( --space-x2 );
    display: none;
    margin-top: var( --space-x2 );
}

.tournament-invitation-inscription-setup__invited-tooltip.baloa-table-column {
    color: var( --white-color );
    font-size: calc( var( --space-half-quarter ) - 1px);
    line-height: calc( var( --space-half-quarter ) + 1px);
}

.tournament-invitation-inscription-setup__del-invitation:hover .tournament-invitation-inscription-setup__invited-tooltip {
   display: block;       
}

.tournament-invitation-inscription-setup__del-invitation {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.tournament-invited-teams-icon_invited{
    margin-right: var(--space);
}

.tournament-invited-teams-col_right_button:hover path{
    fill: var(--white-color);
}

.tournament-invitation-inscription-setup__col__enrolled-actions .icon-options {
    margin: 0 calc( var(--space-half) + var(--space-eighth) );
    cursor: pointer;
}

.tournament-invitation-inscription-setup__view-info.baloa-username {
    color: var( --new-green-color );
    white-space: nowrap;
    cursor: pointer;
}

.tournament-invitation-inscription-setup__col__enrolled-actions .cancel-enrollment {
    display: flex;
    align-items: center;
    justify-content: center;
    height: calc( var(--space-x3) + var(--space-quarter) );
    border-radius: var( --space-half );
    background-color: var( --white-color );
    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);
    padding: 0 var( --space-half-quarter );
    cursor: pointer;
}

.tournament-invitation-inscription-setup__col__enrolled-actions .cancel-enrollment .baloa-table-column {
    color: var( --primary-very-dark-color );
    white-space: nowrap;
    margin-left: var( --space-half );
}

.tournament-invitation-inscription-setup__col__enrolled-actions .cancel-enrollment .icon-x {
    color: var( --error-color );
    border: var( --error-color  ) 2px solid;
    border-radius: 50%;
}

.tournament-invitation-inscription-setup__col__enrolled-actions .cancel-enrollment.hidden {
    display: none;
}

.tournament-invitation-inscription_options {
    display: flex;
    align-items: flex-end;
    position: relative;
    margin-left: 16px;
}

.tournament-invitation-inscription_options-box.active {
    display: flex;
    flex-direction: column;
}

.tournament-invitation-inscription_options-box {
    position: absolute;
    background: var(--white-color);
    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);
    width: 399px;
    right: 0;
    top: 50px;
    display: none;
    border-radius: 8px;
    border: 1px solid var(--new-gray-background-color);
    padding: 16px 16px 8px 16px;
}

.tournament-invitation-inscription_options-box.card-id {
    width: 180px;
    padding: 8px;
    left: 0;
}

.tournament-invitation-inscription_options-box_cancel, .tournament-invitation-inscription_options-box_transfer {
    margin-bottom: 8px;
    padding: var(--space-half);
    border-radius: 8px;
}

.tournament-invitation-inscription_options-box_cancel:hover, .tournament-invitation-inscription_options-box_transfer:hover{
    cursor: pointer;
    background-color: var(--new-background-color);
}

.tournament-invitation-inscription_options-box__card-id-option {
    margin-bottom: 4px;
    padding: 8px;
    border-radius: 8px;
}

.tournament-invitation-inscription_options-box__card-id-option:hover{
    cursor: pointer;
    background-color: var(--new-background-color);
}

.tournament-invited-teams-col_right_button.secondary-button .hubicon-create_team{
    grid-area: icon;
    font-size: 25px;
    color: var(--new-green-color);
}

.tournament-invited-teams-col_right_button.secondary-button:hover .hubicon-create_team,
.tournament-invited-teams-col_right_button.secondary-button:focus .hubicon-create_team{
    color: var(--white-color);
}

.tournament-invited-teams-col_right_button.secondary-button .hubicon-create_team .path2:before {
    color: unset;
}

.tournament-invited-teams-col_right_button.secondary-button .hubicon-create_team .path3:before {
    color: unset;
}
.tournament-invitation-inscription_options-box_cancel .baloa-names, .tournament-invitation-inscription_options-box_transfer .baloa-names{
    color: var(--primary-very-dark-color);
}

.tournament-invitation-inscription-setup__col__registered-actions .icon-options.hide-options {
    visibility: hidden;
}

.tournament-invitation-inscription-setup__search-and-buttons{
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
}

.tournament-invitation-inscription-setup__download-buttons{
    display: flex;
    align-items: center;
}

.tournament-invitation-inscription-setup__download-buttons__button.xs{
    border: 1px solid var(--new-line-color);
    border-radius: 8px;
    padding: 8px 16px;
    color: var(--primary-dark-color);
    margin-left: 16px;
}
.tournament-invitation-inscription-setup__download-buttons__button .hubicon-file_download{
    grid-area: icon;
    padding-right: 16px;
    font-size: 20px;
}

@media screen and ( max-width: 1300px ) {
    .tournament-invitation-inscription-setup__invited-tooltip {
        right: 0;
    }
}

.tournament-create-carnet_button:hover path{
    fill: var(--white-color);
}

.tournament-create-carnet_button:hover {
    color: var(--white-color); 
}

.tournament-create-carnet_button{
    margin-right: 20px;
    padding: 12px;
}

.tournament-create-carnet_button span{
    text-transform: inherit;
}
`, "",{"version":3,"sources":["webpack://./src/app/leagues/components/tournament-invitation-inscription-setup/TournamentInvitationInscriptionSetupComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,gCAAgC;AACpC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,+CAA+C;IAC/C,WAAW;IACX,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;IAChC,kBAAkB;IAClB,+BAA+B;IAC/B,qCAAqC;IACrC,gDAAgD;IAChD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,4CAA4C;IAC5C,4CAA4C;IAC5C,kDAAkD;AACtD;;AAEA;;IAEI,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,sCAAsC;AAC1C;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,sDAAsD;AAC1D;;AAEA;IACI,uCAAuC;IACvC,2DAA2D;IAC3D,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,uDAAuD;IACvD,UAAU;IACV,UAAU;IACV,yDAAyD;IACzD,gBAAgB;IAChB,0CAA0C;IAC1C,gEAAgE;EAClE;;AAEF;IACI,iBAAiB;IACjB,UAAU;IACV,YAAY;IACZ,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,sCAAsC;IACtC,uEAAuE;IACvE,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,iCAAiC;IACjC,2CAA2C;IAC3C,sCAAsC;IACtC,2CAA2C;IAC3C,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;IAClC,0BAA0B;IAC1B,sCAAsC;AAC1C;;AAEA;IACI,+BAA+B;IAC/B,yBAAyB;IACzB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,4BAA4B;IAC5B,yDAAyD;IACzD,WAAW;AACf;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;IAC9B,kBAAkB;IAClB,uBAAuB;IACvB,8BAA8B;IAC9B,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,2BAA2B;IAC3B,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,yCAAyC;IACzC,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,eAAe;IACf,aAAa;IACb,eAAe;AACnB;;AAEA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,0BAA0B;IAC1B,UAAU;AACd;;AAEA;;;IAGI,mBAAmB;IACnB,wCAAwC;IACxC,6BAA6B;AACjC;;AAEA;;IAEI,yDAAyD;IACzD,eAAe;AACnB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,0CAA0C;IAC1C,mDAAmD;IACnD,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,6FAA6F;IAC7F,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,mDAAmD;AACvD;;AAEA;IACI,2CAA2C;IAC3C,sCAAsC;IACtC,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,sCAAsC;IACtC,2BAA2B;IAC3B,mBAAmB;IACnB,mDAAmD;AACvD;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;IACnD,qDAAqD;IACrD,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,mDAAmD;IACnD,qDAAqD;IACrD,mDAAmD;IACnD,sCAAsC;IACtC,iCAAiC;AACrC;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;IACnD,qDAAqD;IACrD,mDAAmD;IACnD,sCAAsC;IACtC,iCAAiC;IACjC,wBAAwB;IACxB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,UAAU;AACd;;AAEA;IACI,8CAA8C;IAC9C,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,+BAA+B;IAC/B,8BAA8B;IAC9B,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;;IAEI,aAAa;;AAEjB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;;;IAGI,yCAAyC;AAC7C;;AAEA;IACI,wDAAwD;IACxD,uCAAuC;IACvC,sCAAsC;IACtC,kBAAkB;IAClB,wBAAwB;IACxB,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;IACnD,qDAAqD;AACzD;;AAEA;GACG,cAAc;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yDAAyD;IACzD,eAAe;AACnB;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sDAAsD;IACtD,kCAAkC;IAClC,sCAAsC;IACtC,iDAAiD;IACjD,sCAAsC;IACtC,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,8CAA8C;IAC9C,YAAY;IACZ,QAAQ;IACR,SAAS;IACT,aAAa;IACb,kBAAkB;IAClB,kDAAkD;IAClD,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,eAAe;IACf,6BAA6B;AACjC;;AAEA;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;AACA;IACI,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,iBAAiB;IACjB,gCAAgC;IAChC,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI;QACI,QAAQ;IACZ;AACJ;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,uBAAuB;AAC3B","sourcesContent":[".tournament-invitation-inscription-setup__container {\n    padding: var( --space-and-half );\n}\n\n.tournament-invitation-inscription-setup__col {\n    width: 30%;\n}\n\n.tournament-invitation-inscription-setup__container .enrolled-team {\n    margin-right: var( --space-half );\n    padding: var( --space ) var( --space-and-half );\n    width: 100%;\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 18px;\n}\n\n.tournament-invitation-inscription-setup__search-input input{\n    background: transparent;\n    width: 100%;\n    border-style: none;\n    font-family: var(--primary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc( var(--space) + 1px );\n    line-height: calc( var(--space-and-half) - 2px );;\n    display: flex;\n    align-items: center;\n    letter-spacing: 0.001em;\n    color: var(--basic-gray-color);\n    padding: var(--space-half-quarter) 0;\n}\n\n.tournament-invitation-inscription-setup__search-input {\n    width: 32%;\n    margin: var( --space-and-half ) 0 !important;\n    background: var(--new-gray-background-color);\n    border-radius: calc( var(--space-and-half) - 2px );\n}\n\n.tournament-invitation-inscription-setup__search-input .MuiInput-underline:before,\n.tournament-invitation-inscription-setup__search-input .MuiInput-underline:hover:not(.Mui-disabled):before {\n    border: none;\n}\n\n.tournament-invitation-inscription-setup__search-input .icon-search {\n    font-size: 20px;\n    margin-left: var( --space-half );\n    margin-right: var( --space-half-quarter );\n    color: #949F9A;\n}\n\n.tournament-invitation-inscription-setup__no-inscriptions__msg {\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 24px;\n}\n\n.tournament-invitation-inscription-setup__no-inscriptions__msg.baloa-table-column {\n    color: var( --basic-gray-color );\n}\n\n.tournament-invitation-inscription-setup__container .icon-ball {\n    color: var(--white-color);\n    padding: 5px;\n    font-size: 30px;\n    border-radius: 50%;\n}\n\n.tournament-invitation-inscription-setup__team {\n    display: flex;\n    align-items: center;\n    /* margin-bottom: var( --space-x2 ); */\n}\n\n/* .tournament-invitation-inscription-setup__team.is-register {\n    margin-bottom: var( --space-half-quarter );\n} */\n\n.tournament-invitation-inscription-setup__enrolled-team {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: var( --space-and-half );\n}\n\n.tournament-invitation-inscription-setup__container img {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n}\n\n.tournament-invitation-inscription-setup__col .request-counter {\n    margin: var( --space-half-quarter ) 0 var( --space ) 0;\n}\n\n.tournament-invitation-inscription-setup__team-info {\n    margin-left:  var(--space-half-quarter);\n    min-height: calc( var( --space-x3 ) - var( --space-half ) );\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.tournament-invitation-inscription-setup__team-info .baloa-table-column {\n    color: var( --primary-very-dark-color );\n}\n\n.tournament-invitation-inscription-setup__team-info .baloa-username {\n    color: var( --primary-dark-color );\n}\n\n.progress {\n    margin: var(--space-half-quarter) 0 var(--space-half) 0;\n    padding: 0;\n    width: 50%;\n    height: calc( var(--space-quarter) + var(--space-eighth));\n    overflow: hidden;\n    background: var( --body-background-color );\n    border-radius: calc( var(--space-quarter) + var(--space-eighth));\n  }\n  \n.bar {\n    position:relative;\n    float:left;\n    min-width:1%;\n    height:100%;\n    background:var( --new-green-color );\n}\n\n.enrolled-players.baloa-table-column {\n    font-size: var( --space-half-quarter );\n    line-height: calc( var( --space-half-quarter ) + var( --space-eighth) );\n    color: var( --basic-gray-color );\n    margin-top: 11px;\n}\n\n.tournament-invitation-inscription-setup__teams-filter {\n    display: flex;\n    align-items: center;\n}\n\n.filter-label.baloa-table-column {\n    color: var( --basic-gray-color );\n    margin-right: var( --space-half );\n    padding: var( --space-half ) var( --space );\n    border-radius: var( --space-and-half );\n    border: 2px solid var( --basic-gray-color );\n    cursor: pointer;\n}\n\n.tournament-invitation-inscription-setup__title {\n    display: flex;\n    justify-content: space-between;\n}\n\n.tournament-invitation-inscription-setup__title .baloa-table-column {\n    color: var( --primary-dark-color );\n    text-transform: capitalize;\n    margin-bottom: var( --space-and-half );\n}\n\n.filter-label.baloa-table-column.selected-state {\n    color: var( --new-green-color );\n    background-color: #EAF7F0;\n    border: 2px solid var(--new-green-color);\n}\n\n.tournament-invitation-inscription-setup__team-container {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 14px 16px 12px 16px;\n    border-bottom: 1px solid var(--new-gray-background-color);\n    width: 100%;\n}\n\n.tournament-invitation-inscription-setup__team-container:last-child {\n    border-bottom: none;\n}\n\n.tournament-invitation-inscription-setup__team-container-header {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n    padding: 12px 16px;\n    align-items: flex-start;\n    border-radius: 8px 8px 0px 0px;\n    background: var(--new-background-color);\n    margin-top: 12px;\n}\n\n.tournament-invitation-inscription-setup__team-container-header__empty-div {\n    width: 120px;\n}\n\n.tournament-invitation-inscription-setup__col__form-and-payment {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    justify-content: flex-start;\n    margin-top: calc(var(--space) + 4px);\n    width: 20%;\n}\n\n.tournament-invitation-inscription-setup__col__form-and-payment__label {\n    padding: 2px 6px;\n    border-radius: 25px;\n    border: 1px solid var(--basic-gray-color);\n    background: rgba(113, 132, 123, 0.15);\n}\n\n.tournament-invitation-inscription-setup__col__form-and-payment__label.baloa-username {\n    color: var(--basic-gray-color);\n}\n\n.tournament-invitation-inscription-setup__col__form-and-payment__label.realized {\n    border: 1px solid var(--new-green-color);\n    background: rgba(48, 179, 107, 0.15);\n}\n\n.tournament-invitation-inscription-setup__col__form-and-payment__label.baloa-username.realized {\n    color: var(--new-green-color);\n}\n\n.tournament-invitation-inscription-setup__col__form-and-payment .hubicon-view_form::before,\n.tournament-invitation-inscription-setup__col__form-and-payment .hubicon-payment_info::before {\n    font-size: 22px;\n    opacity: 0.64;\n    cursor: pointer;\n}\n\n.tournament-invitation-inscription-setup__col__invited-actions,\n.tournament-invitation-inscription-setup__col__registered-actions,\n.tournament-invitation-inscription-setup__col__enrolled-actions {\n    display: flex;\n    align-items: center;\n    justify-content: flex-end;\n    margin-top: var( --space );\n    width: 30%;\n}\n\n.tournament-invitation-inscription-setup__col__invited-actions .primary-button,\n.tournament-invitation-inscription-setup__col__registered-actions .primary-button,\n.tournament-invitation-inscription-setup__col__enrolled-actions .primary-button{\n    background: #EAF7F0;\n    border: 3px solid var(--new-green-color);\n    color: var(--new-green-color);\n}\n\n.tournament-invitation-inscription-setup__col__registered-actions .icon-options,\n.tournament-invitation-inscription-setup__col__invited-actions .icon-options  {\n    margin: 0 calc( var(--space-half) + var(--space-eighth) );\n    cursor: pointer;\n}\n\n.tournament-invitation-inscription-setup__col__invited-actions .invited {\n    background-color: var(--new-blue-color);\n}\n\n.tournament-invitation-inscription-setup__col__enrolled-actions .enrolled {\n    background-color: var( --new-green-color );\n    padding: var( --space-quarter ) var( --space-half );\n    justify-self: flex-start;\n    margin-right: auto;\n}\n\n.tournament-invitation-inscription-setup__col__invited-actions .expired {\n    background-color: var( --basic-gray-color );\n    max-width: calc( var(--space-x3) * 3 );\n    margin-right: calc( var(--space-x3) + var(--space-and-half) - var(--space-eighth)) !important;\n    white-space: nowrap;\n}\n\n.tournament-invitation-inscription-setup__col__registered-actions .baloa-username.rejected {\n    background-color: var( --error-color );\n    color: var( --white-color );\n    white-space: nowrap;    \n}\n\n.tournament-invitation-inscription-setup__col__enrolled-actions .baloa-username.refused {\n    background-color: var( --error-color );\n    color: var( --white-color );\n    white-space: nowrap;\n    margin-right: auto;\n    padding: var( --space-quarter ) var( --space-half );\n}\n\n.tournament-invitation-inscription-setup__col__registered-actions .baloa-username.register {\n    background-color: var( --new-yellow-color );\n    max-width: calc( var(--space-x3) * 3 );\n    white-space: nowrap;\n    color: var( --white-color );\n}\n\n.tournament-invitation-inscription-setup__col__registered-actions .baloa-username.cancelled {\n    background-color: var( --error-color );\n    color: var( --white-color );\n    white-space: nowrap;\n    padding: var( --space-quarter ) var( --space-half );\n}\n\n.tournament-invitation-inscription-setup__col__enrolled-actions .baloa-username {\n    color: var( --white-color );\n    font-size: calc( var( --space-half-quarter ) - 1px);\n    line-height: calc( var( --space-half-quarter ) + 1px);\n    border-radius: var( --space-and-half );    \n    font-weight: var( --font-medium );\n}\n\n.tournament-invitation-inscription-setup__col__invited-actions .baloa-username {\n    margin-right: auto;\n    color: var( --white-color );\n    font-size: calc( var( --space-half-quarter ) - 1px);\n    line-height: calc( var( --space-half-quarter ) + 1px);\n    padding: var( --space-quarter ) var( --space-half );\n    border-radius: var( --space-and-half );    \n    font-weight: var( --font-medium );\n}\n\n.tournament-invitation-inscription-setup__col__registered-actions .baloa-username {\n    color: var( --white-color );\n    font-size: calc( var( --space-half-quarter ) - 1px);\n    line-height: calc( var( --space-half-quarter ) + 1px);\n    padding: var( --space-quarter ) var( --space-half );\n    border-radius: var( --space-and-half );    \n    font-weight: var( --font-medium );\n    justify-self: flex-start;\n    margin-right: auto;\n}\n\n.tournament-invitation-inscription-setup__validate.baloa-username {\n    color: var( --new-green-color );\n    cursor: pointer;\n    padding: 0;\n}\n\n.tournament-invitation-inscription-setup__col__invited-actions span.icon-x {\n    background: var( --new-gray-background-color );\n    color: var( --primary-dark-color );\n    border-radius: 50%;\n    cursor: pointer;\n    font-size: var( --space );\n    padding: var( --space-quarter );\n    width: var( --space-and-half );\n    height: var( --space-and-half );\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__form-and-payment,\n.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__registered-actions {\n    margin-top: 0;\n\n}\n\n.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__registered-actions {\n    justify-content: flex-start;\n}\n\n.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col.baloa-table-column,\n.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__form-and-payment.baloa-table-column,\n.tournament-invitation-inscription-setup__team-container-header .tournament-invitation-inscription-setup__col__registered-actions.baloa-table-column {\n    color: var(--new-primary-very-dark-color);\n}\n\n.tournament-invitation-inscription-setup__invited-tooltip {\n    padding: var( --space-half ) var( --space-half-quarter );\n    background: var( --primary-dark-color );\n    border-radius: var( --space-and-half );\n    position: absolute;\n    right: var( --space-x2 );\n    display: none;\n    margin-top: var( --space-x2 );\n}\n\n.tournament-invitation-inscription-setup__invited-tooltip.baloa-table-column {\n    color: var( --white-color );\n    font-size: calc( var( --space-half-quarter ) - 1px);\n    line-height: calc( var( --space-half-quarter ) + 1px);\n}\n\n.tournament-invitation-inscription-setup__del-invitation:hover .tournament-invitation-inscription-setup__invited-tooltip {\n   display: block;       \n}\n\n.tournament-invitation-inscription-setup__del-invitation {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.tournament-invited-teams-icon_invited{\n    margin-right: var(--space);\n}\n\n.tournament-invited-teams-col_right_button:hover path{\n    fill: var(--white-color);\n}\n\n.tournament-invitation-inscription-setup__col__enrolled-actions .icon-options {\n    margin: 0 calc( var(--space-half) + var(--space-eighth) );\n    cursor: pointer;\n}\n\n.tournament-invitation-inscription-setup__view-info.baloa-username {\n    color: var( --new-green-color );\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.tournament-invitation-inscription-setup__col__enrolled-actions .cancel-enrollment {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: calc( var(--space-x3) + var(--space-quarter) );\n    border-radius: var( --space-half );\n    background-color: var( --white-color );\n    box-shadow: 0px 1px 4px rgba(150, 150, 150, 0.25);\n    padding: 0 var( --space-half-quarter );\n    cursor: pointer;\n}\n\n.tournament-invitation-inscription-setup__col__enrolled-actions .cancel-enrollment .baloa-table-column {\n    color: var( --primary-very-dark-color );\n    white-space: nowrap;\n    margin-left: var( --space-half );\n}\n\n.tournament-invitation-inscription-setup__col__enrolled-actions .cancel-enrollment .icon-x {\n    color: var( --error-color );\n    border: var( --error-color  ) 2px solid;\n    border-radius: 50%;\n}\n\n.tournament-invitation-inscription-setup__col__enrolled-actions .cancel-enrollment.hidden {\n    display: none;\n}\n\n.tournament-invitation-inscription_options {\n    display: flex;\n    align-items: flex-end;\n    position: relative;\n    margin-left: 16px;\n}\n\n.tournament-invitation-inscription_options-box.active {\n    display: flex;\n    flex-direction: column;\n}\n\n.tournament-invitation-inscription_options-box {\n    position: absolute;\n    background: var(--white-color);\n    box-shadow: 0px 1px 4px rgb(150 150 150 / 25%);\n    width: 399px;\n    right: 0;\n    top: 50px;\n    display: none;\n    border-radius: 8px;\n    border: 1px solid var(--new-gray-background-color);\n    padding: 16px 16px 8px 16px;\n}\n\n.tournament-invitation-inscription_options-box.card-id {\n    width: 180px;\n    padding: 8px;\n    left: 0;\n}\n\n.tournament-invitation-inscription_options-box_cancel, .tournament-invitation-inscription_options-box_transfer {\n    margin-bottom: 8px;\n    padding: var(--space-half);\n    border-radius: 8px;\n}\n\n.tournament-invitation-inscription_options-box_cancel:hover, .tournament-invitation-inscription_options-box_transfer:hover{\n    cursor: pointer;\n    background-color: var(--new-background-color);\n}\n\n.tournament-invitation-inscription_options-box__card-id-option {\n    margin-bottom: 4px;\n    padding: 8px;\n    border-radius: 8px;\n}\n\n.tournament-invitation-inscription_options-box__card-id-option:hover{\n    cursor: pointer;\n    background-color: var(--new-background-color);\n}\n\n.tournament-invited-teams-col_right_button.secondary-button .hubicon-create_team{\n    grid-area: icon;\n    font-size: 25px;\n    color: var(--new-green-color);\n}\n\n.tournament-invited-teams-col_right_button.secondary-button:hover .hubicon-create_team,\n.tournament-invited-teams-col_right_button.secondary-button:focus .hubicon-create_team{\n    color: var(--white-color);\n}\n\n.tournament-invited-teams-col_right_button.secondary-button .hubicon-create_team .path2:before {\n    color: unset;\n}\n\n.tournament-invited-teams-col_right_button.secondary-button .hubicon-create_team .path3:before {\n    color: unset;\n}\n.tournament-invitation-inscription_options-box_cancel .baloa-names, .tournament-invitation-inscription_options-box_transfer .baloa-names{\n    color: var(--primary-very-dark-color);\n}\n\n.tournament-invitation-inscription-setup__col__registered-actions .icon-options.hide-options {\n    visibility: hidden;\n}\n\n.tournament-invitation-inscription-setup__search-and-buttons{\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 24px;\n}\n\n.tournament-invitation-inscription-setup__download-buttons{\n    display: flex;\n    align-items: center;\n}\n\n.tournament-invitation-inscription-setup__download-buttons__button.xs{\n    border: 1px solid var(--new-line-color);\n    border-radius: 8px;\n    padding: 8px 16px;\n    color: var(--primary-dark-color);\n    margin-left: 16px;\n}\n.tournament-invitation-inscription-setup__download-buttons__button .hubicon-file_download{\n    grid-area: icon;\n    padding-right: 16px;\n    font-size: 20px;\n}\n\n@media screen and ( max-width: 1300px ) {\n    .tournament-invitation-inscription-setup__invited-tooltip {\n        right: 0;\n    }\n}\n\n.tournament-create-carnet_button:hover path{\n    fill: var(--white-color);\n}\n\n.tournament-create-carnet_button:hover {\n    color: var(--white-color); \n}\n\n.tournament-create-carnet_button{\n    margin-right: 20px;\n    padding: 12px;\n}\n\n.tournament-create-carnet_button span{\n    text-transform: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
